export default function (eventName, eventData, dataLayer) {
    dataLayer.push({
        event: eventName,
        [eventName]: eventData,
    });
}
